<template>
  <v-menu
    :key="basemap"
    bottom
    left
    offset-y
    :nudge-bottom="5"
    :close-on-content-click="false"
    content-class="tw:pointer-events-auto tw:shadow-none reset-contain"
  >
    <template #activator="{ on, attrs }">
      <base-button v-on="on" icon="$mapCard" type="map-control" class="tw:pointer-events-auto">
        <div class="tw:max-w-[200px] tw:truncate">{{ selectedBasemapData?.name }}</div>
        <template #appendIcon>
          <v-icon small :class="{ 'tw:rotate-180': attrs['aria-expanded'] === 'true' }"> mdi-chevron-down </v-icon>
        </template>
      </base-button>
    </template>
    <v-card class="tw:px-3 tw:py-3 tw:max-w-[200px] tw:ml-auto tw:shadow-md">
      <v-radio-group class="tw:flexcol-2.5 tw:m-0" hide-details :value="basemap" @change="onBasemapChange">
        <v-radio
          v-for="basemap in basemaps"
          :key="basemap.id"
          :value="basemap.id"
          :label="basemap.name"
          :ripple="false"
          class="tw:[&_label]:text-xs tw:[&_label]:text-font"
        />
      </v-radio-group>
    </v-card>
  </v-menu>
</template>

<script>
import { getContext } from '@/assets/js/mapContext';
import { get } from 'vuex-pathify';

export default {
  name: 'BasemapSelect',
  inject: {
    mapContext: {
      default: null,
    },
  },
  props: {
    basemap: {
      type: [Number, null],
    },
  },
  computed: {
    basemapSchema: get('layers/layersSchemaByScope@basemap@[0]'),
    basemapLayers: get('layers/basemapLayers'),
    blankBasemapVisible: get('admin/settingsValues@basemap_blank_visible'),
    selectedBasemapData() {
      if (!this.basemap) return this.basemaps.at(-1);
      return this.basemapLayers[this.basemap];
    },
    basemaps() {
      return [
        ...(this.basemapSchema?.layers?.filter(layer => layer.visible) ?? []),
        ...(this.blankBasemapVisible
          ? [
              {
                id: null,
                name: this.$i18n.t('admin.basemaps.empty'),
                service_type: 'empty',
              },
            ]
          : []),
      ];
    },
  },
  watch: {
    basemap: {
      handler(newBasemapId) {
        this.$nextTick(() => getContext(this).$emit('changeBasemap', newBasemapId));
      },
      immediate: true,
    },
  },
  methods: {
    onBasemapChange(newBasemapId) {
      this.$emit('change', newBasemapId);
    },
  },
  mounted() {
    if (this.basemaps.find(layer => layer.id === this.basemap)) return;
    this.$emit('change', this.basemaps[0].id);
  },
};
</script>

<style>
.reset-contain {
  contain: initial !important;
  overflow: visible !important;
}
</style>
